/**
 * The customer's own logo beside the tenant name in the header. It sits on a
 * white tile so any customer logo stays legible on the navy bar. Decorative:
 * the tenant name beside it is the accessible name.
 */
export default function CustomerLogo({ logo }) {
  if (!logo?.url) return null;
  return (
    <span data-testid="customer-logo" className="flex h-8 shrink-0 items-center rounded bg-white px-1.5">
      <img
        src={logo.url}
        alt=""
        referrerPolicy="no-referrer"
        className="max-h-6 w-auto max-w-[7.5rem] object-contain"
      />
    </span>
  );
}
